import React, { useEffect, useState } from "react";
import { todayWorkflowFollowUpData } from "../common/Helper";

import { useStateProvider } from "../common/StateProvider";
import { DateRangeIcon } from "../common/Icon";
import MarkCompletedModal from "./MarkCompletedModal";
import CancelDeleteModal from "./CancelDeleteModal";

import TodayWorkflowItemProfile from "./TodayWorkflowItemProfile";

const FollowUpsItem = () => {
  const {
    setTodaysWorkflowProfile,
    setTodaysWorkflowIndex,
    setTodayWorkflowUpdate,
  } = useStateProvider(); // Get Profile
  const { profileItemPage, setProfileItemPage } = useStateProvider(); //TODAY WORKFLOW ITEM PROFILE PAGE
  const { deleteModal, setDeleteModal } = useStateProvider();
  const { deletModalHeading, setdeletModalHeading } = useStateProvider(); //DELETE MODEL HEADING
  const { markModal, setmarkModal } = useStateProvider(); //Mark Complete MODEL
  const { markCompleteModalHeading, setmarkCompleteModalHeading } =
    useStateProvider(); //Mark Complete MODEL HEADING
  const [todayWorkflowContactArray, setTodayWorkflowContactArray] = useState([
    ...todayWorkflowFollowUpData, // Use the spread operator to create a copy of the array
  ]);
  const [deleteItemIndex, setDeleteItemIndex] = useState(null);

  // Function to show the Productivity modal
  const opendeleteModal = (value, index) => {
    setDeleteModal(true);
    setdeletModalHeading(value.followUpModeltext);
    setDeleteItemIndex(index); // Store the index
  };

  // Function to show the Mark Complete MODAL
  const openMarkCompleteModel = (value) => {
    setmarkModal(true);
    setmarkCompleteModalHeading(value.markCompletedModelHeading);
  };

  const deleteCard = () => {
    if (deleteItemIndex !== null) {
      const updatedData = [...todayWorkflowContactArray];
      updatedData.splice(deleteItemIndex, 1);
      setTodayWorkflowContactArray(updatedData);
      setDeleteModal(false); // Close the modal after deletion
    }
  };

  // Function to show the Today Workflow Item Profile Page
  const openProfileItemPage = (value, index) => {
    setProfileItemPage(true);
    setTodaysWorkflowProfile(value);
    setTodaysWorkflowIndex(index);
    setTodayWorkflowUpdate(todayWorkflowContactArray);
  };

  // OVERLAY BEHIND FILTER MODEL
  const overLayHidden = () => {
    setProfileItemPage(!profileItemPage);
  };

  // OVERFLOW HIDDEN WHEN FILTER MODEL OPEN
  useEffect(() => {
    if (profileItemPage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [profileItemPage]);
  return (
    <>
      <div className="w-[550px] xm:w-auto overflow-x-auto">
        {todayWorkflowContactArray.map((value, index) => (
          <div
            className=" p-[7px_10px] rounded-md border-[0.2px] border-solid border-black/10 bg-white hover:shadow-workflow_item_card_shadow duration-300 cursor-pointer mb-2"
            key={index}>
            <div className="flex items-center justify-between">
              <div
                onClick={() => openProfileItemPage(value, index)}
                className="flex items-center gap-4 w-full">
                <img src={value.newContactImg} alt="teams" />
                <div>
                  <div className=" flex items-center gap-4">
                    <h5 className="text-sm 3xl:text-[16px] font-normal text-black">
                      {value.newContactNameText}
                    </h5>
                    <div className="flex gap-1">
                      <span>{value.followUptatusIcon}</span>
                      <p
                        className={`${value.followUpLevelTextColor} text-xs 3xl:text-[14px] font-normal pr-1`}>
                        {value.followUpLevelText}
                      </p>
                    </div>
                    <p
                      className={` ${value.followUpLabelBtnBgColor} text-[8px] 3xl:text-[11px] font-bold text-white p-[4px_10px] rounded-[38px] `}>
                      {value.followUpLabelBtn}
                    </p>
                  </div>
                  <div className=" flex gap-4 pt-1">
                    <div className="flex gap-1">
                      <p className="text-[10px] 3xl:text-[12px] font-normal text-gray">
                        {value.followUpOnText}
                      </p>
                      <span className="text-[10px] 3xl:text-[12px] font-normal text-primary">
                        {value.followUpOnDate}
                      </span>
                    </div>
                    <div className=" flex items-center gap-1">
                      <span>
                        <DateRangeIcon />
                      </span>
                      <p className="text-[10px] 3xl:text-[12px] font-normal text-gray">
                        {value.followUpFullDate}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" flex items-center gap-[6px]">
                <button
                  onClick={() => openMarkCompleteModel(value)}
                  className="text-[10px] 3xl:text-[12px] w-[115px] 3xl:w-[130px] markComplete-btn font-semibold text-gray p-[5px_6px] rounded border-[0.851px] border-solid border-[rgba(0,_0,_0,_0.20)] flex items-center gap-1 hover:bg-primary hover:text-white hover:border-transparent duration-200 markComplete-btn">
                  <span className="markCompleteIcon-icon">
                    {value.markCompleteIcon}
                  </span>
                  {value.markCompleteBtn}
                </button>
                <span onClick={() => opendeleteModal(value, index)}>
                  {value.deleteWorkflowIcon}
                </span>
                <span onClick={() => openProfileItemPage(value, index)}>
                  {value.rightArrow}
                </span>
              </div>
            </div>
          </div>
        ))}
        {/* DELETE MODAL HEADING */}
        {deleteModal && (
          <CancelDeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deletModalHeading={deletModalHeading}
            deleteCard={deleteCard}
          />
        )}
        <div className="fixed right-0 md:right-4 top-0 z-30">
          {profileItemPage && (
            <TodayWorkflowItemProfile
              setProfileToggle={setProfileItemPage}
              setProfileItemPage={openProfileItemPage}
            />
          )}
        </div>
        <div
          onClick={overLayHidden}
          className={` fixed inset-0 min-h-full z-20  bg-black opacity-10 ${
            profileItemPage ? "w-[100%] " : "hidden"
          }`}></div>
        {/* Mark Complete MODAL */}
        {markModal && (
          <MarkCompletedModal
            markModal={markModal}
            setmarkModal={setmarkModal}
            markCompleteModalHeading={markCompleteModalHeading}
          />
        )}
      </div>
    </>
  );
};

export default FollowUpsItem;
